import Icon from "@material-ui/icons/Person";
import AreasCreate from "./CcaAreasCreate";
import AreasEdit from "./CcaAreasEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaAreas",
  edit: AreasEdit,
  create: AreasCreate,
  icon: Icon,
};
